// i18n.ts
import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import {en} from "./en";
import {de} from "./de";
import {Country_Code_Enum} from "../generated/graphql";

export enum Language {
    EN = "en",
    DE = "de"
}

export function countryCodeFromLanguage(language?: string): Country_Code_Enum {


    // Wenn kein Sprachparameter übergeben wurde, prüfe URL-Parameter
    if (!language) {
        const urlParams = new URLSearchParams(window.location.search);
        language = urlParams.get('language')?.toLowerCase() || Language.DE;
    }

    switch (language) {
        case Language.EN:
            return Country_Code_Enum.En;
        case Language.DE:
            return Country_Code_Enum.De;
        default:
            console.warn("Unknown language: " + language);
            return Country_Code_Enum.De;
    }
}

// Initialisieren von i18n mit der Sprache aus der URL
const urlParams = new URLSearchParams(window.location.search);
const langParam = urlParams.get('language')?.toLowerCase() || Language.DE;

i18n
    .use(initReactI18next)
    .init({
        resources: {
            de: { translation: { ...de } },
            en: { translation: { ...en } },
        },
        lng: langParam,
        fallbackLng: Language.DE,
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
